import React, { useState, useEffect, useContext } from 'react';
import db from '../firebase';
import axios from 'axios';
import { Button, Typography, CircularProgress } from '@mui/material';
import { collection, addDoc, getDocs, setDoc, doc, getDoc, FieldValue, serverTimestamp } from 'firebase/firestore';
import * as cheerio from 'cheerio';
import { FeedbackContext } from '../contexts/FeedbackContext';
import { SpinnerContext } from '../contexts/SpinnerContext';
import { MetadataContext } from '../contexts/MetadataContext';
import { ArticlesContext, useArticles } from '../contexts/ArticlesContext';
import ProcessArticles from './ProcessArticles';




const FetchRSS = () => {
  //const [lastFetch, setLastFetch] = useState(null);
  const [progress, setProgress] = useState('');
  const [completionMessage, setCompletionMessage] = useState('');
  const [processedCount, setProcessedCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { showFeedback } = useContext(FeedbackContext);
  const { showSpinner, hideSpinner } = useContext(SpinnerContext);
  const { metadata, updateMetadata, setMetadata } = useContext(MetadataContext);
  const { articles, setArticles, fetchInitialArticles } = useArticles();
  const [feedDocIds, setFeedDocIds] = useState({});


  /* useEffect(() => {
    const fetchLastFetchTime = async () => {
      const lastFetchDoc = await getDoc(doc(db, 'metadata', 'lastFetch'));
      if (lastFetchDoc.exists()) {
        setLastFetch(lastFetchDoc.data().datetime.toDate());
      }
    };
    fetchLastFetchTime();
  }, []); */

  const fetchAndStoreRssData = async () => {
    console.log("lastFetch: ", metadata.lastFetch)
    setCompletionMessage('');
    setProcessedCount(0);
    setIsLoading(true);
    showSpinner('Fetching RSS feeds...');
    //console.log('last fetch date:', metadata.lastFetch);
    const now = new Date();
    const rssFeeds = await getDocs(collection(db, 'rssFeeds'));
    const urlToDocId = {};
    const rssUrls = rssFeeds.docs.map(doc => {
      urlToDocId[doc.data().url] = doc.id;
      return doc.data().url;
    });
    setFeedDocIds(urlToDocId);
    let filteredArticles = [];
    let numberOfFetchedArticles = 0;
    const articleURLs = new Set();

    // Add this helper function at the top of the component
    const isFutureDate = (date) => {
      return new Date(date) > new Date();
    };

    // Create logRSSResponse inside fetchAndStoreRssData to access urlToDocId
    const logRSSResponse = async (url, responseData, error = null) => {
      try {
        const feedId = urlToDocId[url]; // Use urlToDocId instead of feedDocIds
        if (!feedId) {
          console.error('No document ID found for URL:', url);
          return;
        }
        console.table('response data:', responseData);

        const rssLogRef = collection(db, 'rssFeeds', feedId, 'logs');
        await addDoc(rssLogRef, {
          timestamp: serverTimestamp(),
          status: responseData?.status || 'error',
          itemCount: responseData?.items?.length || 0,
          items: responseData?.items || [],
          feed: responseData?.feed || null,
          error: error ? {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status
          } : null
        });
      } catch (logError) {
        console.error('Error logging RSS response:', logError);
      }
    };

    try {
      for (let i = 0; i < rssUrls.length; i++) {
        const url = rssUrls[i];
        showSpinner(`Fetching RSS ${i + 1} out of ${rssUrls.length}. ${numberOfFetchedArticles} articles saved`);

        console.log(`Fetching RSS feed from: ${url}`);
        try {
          const response = await axios.get(`https://api.rss2json.com/v1/api.json?rss_url=${url}&api_key=rcp6suz4cga6o5rdefgwoeiwdm84c9lbm8i1apvs&count=30`);

          // Log successful response
          await logRSSResponse(url, response.data);

          // Add detailed response debugging
          console.log(`📥 RSS2JSON Response for ${url}:`, {
            status: response.data.status,
            itemCount: response.data.items?.length || 0,
            feed: response.data.feed,
            hasError: response.data.status !== 'ok'
          });
          if (response.data.status === 'ok') {
            showSpinner(`Saving articles from RSS ${i + 1} out of ${rssUrls.length}`);
            const articles = response.data.items.map(async item => {
              const $ = cheerio.load(item.description);
              let googleImageLink = null;
              let externalLink = null;
              // try {
              //   const pubDate = new Date(item.pubDate);
              //   console.log("pubDate:",pubDate," Last Fetch:",metadata.lastFetch)
              //   if (!item.enclosure?.link && (!metadata.lastFetch || pubDate > metadata.lastFetch)) {
              //     const googleResponse = await axios.get(`https://www.googleapis.com/customsearch/v1?key=AIzaSyBng68IQbXvc6jLZoYAPHN-Kny1c9ee8LY&searchType=image&cx=74272fee9b65e44bb&&imageSearchResultSetSize=1&q=${encodeURIComponent(item.link)}`);
              //     if (googleResponse.data.items && googleResponse.data.items.length > 0) {
              //       googleImageLink = googleResponse.data.items[0].image.thumbnailLink;
              //     }
              //   }
              // } catch (googleError) {
              //   console.error(`Error fetching image from Google for ${item.link}:`, googleError);
              // }

              // Check if the feed URL is from Reddit
              if (url.includes('reddit.com') || url.includes('redd.it')) {
                // Extract the external URL from the description in the Reddit post
                const links = $('a').map((i, el) => $(el).attr('href')).get();
                externalLink = links.find(link => !link.includes('reddit.com') && !link.includes('redd.it'));
              }

              return {
                title: item.title,
                link: externalLink || item.link,
                description: (url.includes('reddit.com') || url.includes('redd.it')) ? '' : $.text(), // Set description to empty if from Reddit or Remove HTML tags
                pubDate: new Date(item.pubDate),
                image: item.enclosure?.link || item.media?.url || decodeURI(item.thumbnail),
                googleImage: googleImageLink,
                status: 'new', // Set default status to 'new'
                feedURL: url,
                TLDR: '',
                vote:0,
                insightfullCount:0,
                //timestamp: firebase.firestore.FieldValue.serverTimestamp(), // Add Firebase timestamp 
                //fullitem: item
              };
            });

            //const articleURLs = new Set();
            const resolvedArticles = await Promise.all(articles);

            // Convert metadata.lastFetch to a JavaScript Date object if it is a Firestore Timestamp
            let lastFetchDate;
            if (metadata.lastFetch.toDate) {
              lastFetchDate = metadata.lastFetch.toDate();
            } else {
              lastFetchDate = new Date(metadata.lastFetch);
            }

            // Filter articles based on pubDate (avoid future date)
            // Modify the filtering section where articles are processed
            const filteredArticles = resolvedArticles.filter(item => {
              const articleDate = new Date(item.pubDate);
              return articleDate > lastFetchDate && !isFutureDate(articleDate);
            });

            // Add logging for skipped future articles
            if (resolvedArticles.some(item => isFutureDate(item.pubDate))) {
              console.warn(`Skipped articles with future dates from ${url}:`,
                resolvedArticles
                  .filter(item => isFutureDate(item.pubDate))
                  .map(item => ({
                    title: item.title,
                    pubDate: new Date(item.pubDate),
                    feedURL: url
                  }))
              );
            }
            if (filteredArticles.length > 0) {
              for (let article of filteredArticles) {
                try {
                  await addDoc(collection(db, 'articles'), article);
                  numberOfFetchedArticles++;
                  //console.log(`Article ${article.title} fetched and stored successfully with pubBate ${article.pubDate}, compared to lastFetch ${lastFetchDate}`);
                  // Check if the article URL is already in the Set
                  if (!articleURLs.has(article.link)) {
                    console.log(`Article ${article.title} fetched and stored successfully with pubBate ${article.pubDate}`);
                    setArticles(prevArticles => [article, ...prevArticles]);
                    articleURLs.add(article.link); // Add the article URL to the Set
                    console.table(articleURLs);
                  }
                } catch (writeError) {
                  console.error(`Error writing article ${article.title} to Firestore:`, writeError);
                }

              }
            }
          } else {
            console.warn(`⚠️ Feed ${url} returned non-OK status:`, {
              status: response.data.status,
              message: response.data.message || 'No error message provided',
              response: response.data
            });
            showFeedback(`Failed to fetch RSS feed: ${url}`, 'warning');
          }


        } catch (fetchError) {
          // Log error response
          await logRSSResponse(url, null, fetchError);

          console.error(`❌ Error fetching data from URL ${url}:`, {
            error: fetchError.message,
            response: fetchError.response?.data,
            status: fetchError.response?.status
          });
          console.error(`Error fetching data from URL ${url}:`, fetchError);
        }
      }
      // Update the lastFetch time in Firestore
      //await setDoc(doc(db, 'metadata', 'lastFetch'), { datetime: now });
      //setLastFetch(now);
      // Update the lastFetch field in the metadata
      const currentDateTime = serverTimestamp()//new Date().toISOString();
      await updateMetadata({ lastFetch: currentDateTime, lastFetchArticleCount: numberOfFetchedArticles });
      console.log('Fetch completed, metadata updated');
      // Add fetch history entry
      const historyRef = collection(db, 'metadata', 'fetchHistory', 'entries');
      await addDoc(historyRef, {
        timestamp: currentDateTime,
        articlesCount: numberOfFetchedArticles,
        success: true,
        feedsProcessed: rssUrls.length
      });

      showFeedback(`${numberOfFetchedArticles} RSS feeds fetched and stored successfully.`, 'success');
      console.log(`${numberOfFetchedArticles} RSS feeds fetched and stored successfully.`);

      setProcessedCount(numberOfFetchedArticles);
      setCompletionMessage('Done!');
    }
    catch (error) {
      // Log failed fetch attempt
      const historyRef = collection(db, 'metadata', 'fetchHistory', 'entries');
      await addDoc(historyRef, {
        timestamp: serverTimestamp(),
        error: error.message,
        success: false
      });
      showFeedback(`Error fetching RSS feeds: ${error.message}`, 'error');
      console.log(`Error fetching RSS feeds: ${error.message}`)
      showFeedback(`Error fetching RSS feeds: ${error.message}`, 'error');
      setCompletionMessage('Failed to complete');
    } finally {
      // Ensure pubDate is a valid Date object or timestamp
      const sortedArticles = articles.map(article => ({
        ...article,
        pubDate: new Date(article.pubDate)
      })).sort((a, b) => b.pubDate - a.pubDate);

      // Update the state with the new sorted array
      //setArticles([...sortedArticles]);
      fetchInitialArticles();
      setIsLoading(false);
      setProgress('');
      hideSpinner();
    }

  };

  return (
    <div>
      <h2>Fetch RSS Feeds</h2>
      <Button onClick={fetchAndStoreRssData} variant="contained" color="primary" disabled={isLoading} id="fetch">
        Fetch RSS Feeds
      </Button>
      {isLoading && (
        <div style={{ marginTop: '20px' }}>
          <Typography variant="body1" style={{ marginTop: '10px' }}>{progress}</Typography>
        </div>
      )}
      {completionMessage && (
        <><div style={{ marginTop: '20px' }} id="completionMessage">
          <Typography variant="h6" color="primary">
            {completionMessage}
          </Typography>
          {processedCount > 0 && (
            <Typography variant="body1" color="textSecondary">
              Processed {processedCount} articles
            </Typography>
          )}
        </div>
          <ProcessArticles /></>
      )}
    </div>
  );
};

export default FetchRSS;
